import moment from 'moment'
import axios from "axios";

export function formatDateIndo(dateValue) {
    var date=new Date(dateValue)
    var monthNames = [
      "Januari", "Februari", "Maret",
      "April", "Mei", "Juni", "Juli",
      "Agustus", "September", "Oktober",
      "November", "Desember"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var outputDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
    return outputDate;
}
export function timeAgo(unxTimestamp) {
    var newDate = moment.unix(unxTimestamp).fromNow();
    return newDate
}
export function monitoringStatusLabel(status) {
    let label = status;
    if (status == 'raw') {
        label = "Raw"
    } else if (status == 'processing') {
        label = "In Progress"
    } else if (status == 'reopen') {
        label = "Reopen"
    } else if (status == 'need_review') {
        label = "Need Review"
    } else {
        label = "Closed"
    }
    return label
}

export function monitoringStatusLabelStyle(status) {
    let label = status;
    if (status == 'raw') {
        label = "<span class='label-light text-danger'>" + monitoringStatusLabel(status) + "</label>"
    } else if (status == 'processing') {
        label = "<span class='text-warning'><i class='fa fa-clock-o'></i> " + monitoringStatusLabel(status) + "</label>"
    } else if (status == 'reopen') {
        label = "<span class='text-primary'><i class='fa fa-repeat'></i> " + monitoringStatusLabel(status) + "</label>"
    } else if (status == 'need_review') {
        label = "<span class='text-success'><i class='fa fa-retweet'></i> " + monitoringStatusLabel(status) + "</label>"
    } else {
        label = "<span class='text-blue'><i class='fa fa-check'></i>  " + monitoringStatusLabel(status) + "</label>"
    }
    return label
}
export function marketplaceLabelFilter(sortBy, orderBy) {
    let label = sortBy;
    if (sortBy == 'price' && orderBy == 'asc') {
        label = "Harga: Rendah ke Tinggi"
    } else if (sortBy == 'price' && orderBy == 'desc') {
        label = "Harga: Tinggi ke Rendah"
    } else if (sortBy == 'relevancy') {
        label = "Terkait"
    } else if (sortBy == 'ctime') {
        label = "Terbaru"
    } else if (sortBy == 'sales') {
        label = "Terlaris"
    }
    return label
}

export function getFirstLastDayInWeek() {
    var curr = new Date; // get current date
    var first = curr.getDate() - curr.getDay(); // First day is the day of the month - the day of the week
    var last = first + 6; // last day is the first day + 6

    var firstday = new Date(curr.setDate(first)).toUTCString();
    var lastday = new Date(curr.setDate(last)).toUTCString();
    var resp = {};
    resp = {
        "firstday": firstday,
        "lastday": lastday,
    }
    return resp;
}

export function marketplaceIcon(value) {
    let urlImg = '<img  class="rounded-circle" style="width:50px;" src="../../static/marketplace/emoji.png">';
    switch (value) {
        case "shopee":
            urlImg = '<img  class="rounded-circle" style="width:50px;" title="Shopee" alt="Shopee" src="../../static/marketplace/shopee.png">';
            break;
        case "lazada":
            urlImg = '<img  class="rounded-circle" style="width:50px;" title="Lazada" alt="Lazada" src="../../static/marketplace/lazada.png">';
            break;
        case "bukalapak":
            urlImg = '<img  class="rounded-circle" style="width:50px;" title="Bukalapak" alt="Bukalapak" src="../../static/marketplace/bukalapak.png">';
            break;
        case "tokopedia":
            urlImg = '<img  class="rounded-circle" style="width:50px;" title="Tokopedia" alt="Tokopedia" src="../../static/marketplace/tokopedia.png">';
            break;
        case "tiktok":
            urlImg = '<img  class="rounded-circle" style="width:50px;" title="Tokopedia" alt="Tokopedia" src="../../static/marketplace/tiktok.png">';
            break;
    }
    return urlImg
}

export async function downloadImage(url, title) {
    if (typeof (title) == 'undefined' || title == "") {
        title = "file"
    }
    var base64 = await axios
        .get(url, {
            responseType: "arraybuffer"
        })
        .then(response =>
            // Buffer.from(response.data, "binary").toString("base64")
            forceFileDownload(response, title + ".jpeg")

        );
    var img = new Image();
    img.src = "data:image/jpeg;base64, " + base64;
    return img;
}
export function forceFileDownload(response, title) {
    console.log(title)
    const url = window.URL.createObjectURL(new Blob([response.data]))
    const link = document.createElement('a')
    link.href = url
    link.setAttribute('download', title)
    document.body.appendChild(link)
    link.click()
}
export function hasPermissionForRoute(roles, route) {
    if (route.meta && route.meta.roles) {
        return roles.some(role => route.meta.roles.includes(role))
    } else {
        return true
    }
}

export function labelPackageProduct(value) {
    let label = value;
    if (value == "monthly") {
        label = "1 Bulan"
    } else if (value == "3months") {
        label = "3 Bulan"
    } else if (value == "annually") {
        label = "1 Tahun"
    }
    return label
}


export function labelPackageProductEnglish(value) {
    let label = value;
    if (value == "monthly") {
        label = "1 Month"
    } else if (value == "3months") {
        label = "3 Months"
    } else if (value == "annually") {
        label = "1 Year"
    }
    return label
}

export function labelStatusMessage(value) {
    value = parseInt(value)
    let label = value;
    if (value == 0) {
        label = "ERROR"
    } else if (value == 1) {
        label = "PENDING"
    } else if (value > 1) {
        label = "SUCCESS"
    }
    return label
}
export function calculateSeconds(second) {
    var d = second;
    var r = {};                                                                // result
    var s = {                                                                  // structure
        year: 31536000,
        month: 2592000,
        week: 604800, // uncomment row to ignore
        day: 86400,   // feel free to add your own row
        hour: 3600,
        minute: 60,
        second: 1
    };

    Object.keys(s).forEach(function (key) {
        // console.log("d", d)
        r[key] = Math.floor(d / s[key]);
        d -= r[key] * s[key];
    });

    let label = ""
    let index = 0
    Object.keys(r).forEach(function (key) {
        // console.log("keyy", key)
        // r[key] = Math.floor(d / s[key]);
        // d -= r[key] * s[key];

        if (r[key] > 0) {
            label += (index == 0) ? (r[key] + key) : " " + (r[key] + key)
        }
        index++
    });
    // r.forEach(row,ind)
    // console.log("rrr", r)

    return label;
}



export function getCurrentMonth() {
    var date = new Date()

    var year = date.getFullYear();
    var monthIndex = date.getMonth();
    var monthDisp = monthIndex + 1;
    monthDisp = (monthDisp < 10) ? '0' + monthDisp : monthDisp;
    return year + "-" + monthDisp;
}
export function nFormatter(num) {
    if (num >= 1000000000) {
        return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    }
    if (num >= 1000000) {
        return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    }
    if (num >= 1000) {
        return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
    }
    return num;
}

export function convertQtyFromQuoteAsset(numQuote, price) {
    let numQuoteNumber = parseFloat(numQuote)
    let priceNumber = parseFloat(price)

    if (numQuoteNumber <= 0 || priceNumber <= 0) {
        return 0;
    } else {
        return Math.ceil((nrOfDecimals(numQuoteNumber / priceNumber)))
    }
}

export function convertClearenceQtyToQuoteAsset(numQty, price) {
    let numQtyNumber = parseFloat(numQty)
    let priceNumber = parseFloat(price)

    if (numQtyNumber <= 0 || priceNumber <= 0) {
        return 0;
    } else {
        return Math.floor(nrOfDecimals(numQtyNumber * priceNumber))
    }
}

export function convertTzDatetimeToHour(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");
    return newDate.format("HH:mm")
}
export function convertTzDatetimeToDateISO(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");
    return newDate.format("YYYY-MM-DD")
}
export function convertTzDatetimeToUnixv2(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DDTHH:mm:ssZ");

    return newDate.unix()
}

export function convertTzDatetimeToUnix(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DD HH:mm:ss");

    return newDate.unix()
}

export function convertUTCDatetimeToUnix(utcDateTime) {
    var newDate = moment.utc(utcDateTime, "YYYY-MM-DD HH:mm:ss");

    return newDate.unix()
}


export function currentDateTimeUnix() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().unix()

    return dateLocal;
}

export function currentDateTimeUTC() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().utc().format()

    return dateLocal;
}


export function currentDate() {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment().format(
            "dddd, Do MMMM YYYY"
        )

    return dateLocal;
}

export function formatHourFromUnix(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "HH:mm"
        )

    return dateLocal;
}


export function formatLocalDateWithDay(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "dddd, Do MMMM YYYY HH:mm"
        )

    return dateLocal;
}


export function formatLocalDate(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "Do/MM/YYYY, HH:mm"
        )

    return dateLocal;
}

export function formatLocalDateYMD(unxTimestamp) {
    // console.log("moment", moment)
    // console.log("unxTimestamp", unxTimestamp)
    let dateLocal =
        moment.unix(unxTimestamp).format(
            "YYYY-MM-DD HH:mm:ss"
        )

    return dateLocal;
}

// export function formatLocalDate(unxTimestamp) {
//     var date = new Date(unxTimestamp * 1000);
//     var newDate = new Date(date.getTime() + date.getTimezoneOffset() * 60 * 1000);

//     var offset = date.getTimezoneOffset() / 60;
//     var hours = date.getHours();
//     // console.log("offset", offset)
//     // newDate.setHours(hours - offset);
//     newDate.setHours(hours);

//     return newDate;
// }
export function nrOfDecimals(number) {
    var match = ('' + number).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) { return 0; }

    var decimals = Math.max(0,
        (match[1] ? match[1].length : 0)
        // Correct the notation.
        - (match[2] ? +match[2] : 0));

    if (decimals > 8) {
        //if decimal are more then 8
        number = parseFloat(number).toFixed(8);
    } else {
        number = parseFloat(number).toFixed(decimals);
    }
    // else no adjustment is needed
    return (number * 1);
    // var noZeroes = number.toString()
    // return noZeroes;
    // return +(Math.round(number + "e+2")  + "e-2");

}

export function formatPriceRupiah(value) {
    let val = (value / 1).toFixed(0).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}


export function formatPrice(value) {
    let val = (value / 1).toFixed(0).replace(',', '.')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
}

export function formatSizes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}
//getWhatsappNumberFromJid
export function getWhatsappNumberFromJid(number) {
    console.log("getWhatsappNumberFromJid:", number)
    if (number != "") {
        //check is grup
        // var splitArr = number.split("@g")
        // console.log("splitArr:", splitArr)
        // console.log("regex:", number.match('@g'))
        if (number.match('@g') != null) {
            // number = splitArr[0]
            return number
        }
        var splitArr = number.split("@")
        if (splitArr.length > 0) {
            number = splitArr[0]
            return number
        }
    }

    return number
}

//getWhatsappJid
export function getWhatsappJid(number) {
    var suffix = "@s.whatsapp.net"
    return number + suffix
}

export function formatDate(dateValue, formatType = "month_name") {
    var date = new Date(dateValue)
    var monthNames = [
        "Jan", "Feb", "Mar",
        "Apr", "May", "Jun", "Jul",
        "Aug", "Sep", "Oct",
        "Nov", "Dec"
    ];

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var outputDate = ""
    if (Number.isNaN(monthIndex) == true) {
        return "-"
    }
    switch (formatType) {
        default:
            outputDate = day + ' ' + monthNames[monthIndex] + ' ' + year;
            break;
        case "iso":
            var isoDate = new Date(year, monthIndex, day);
            outputDate = isoDate.toISOString().slice(0, 10);
            break;
        case 'datetime':
            var hours = date.getHours();
            hours = (hours < 10) ? '0' + hours : hours
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            monthIndex = (monthIndex + 1)
            monthIndex = (monthIndex < 10) ? "0" + monthIndex : monthIndex
            day = (day < 10) ? "0" + day : day
            minutes = (minutes < 10) ? "0" + minutes : minutes
            seconds = (seconds < 10) ? "0" + seconds : seconds
            outputDate = day + '/' + monthIndex + '/' + year + " " + hours + ":" + minutes + ":" + seconds;
            break;
    }
    return outputDate;
}

//formatDateForMessage
export function formatDateForMessage(dateValue, formatType = "ISODatetime") {
    var date = new Date(dateValue)

    var day = date.getDate();
    var monthIndex = date.getMonth();
    var year = date.getFullYear();
    var outputDate = ""
    if (Number.isNaN(monthIndex) == true) {
        return "-"
    }

    var hours = date.getHours();
    hours = (hours < 10) ? '0' + hours : hours
    var minutes = date.getMinutes();
    var seconds = date.getSeconds();
    monthIndex = (monthIndex + 1)
    monthIndex = (monthIndex < 10) ? "0" + monthIndex : monthIndex
    day = (day < 10) ? "0" + day : day
    minutes = (minutes < 10) ? "0" + minutes : minutes
    seconds = (seconds < 10) ? "0" + seconds : seconds
    switch (formatType) {

        case 'MinuteHour':
            outputDate = hours + ":" + minutes;
            break;
        case 'ISODate':
            outputDate = year + '-' + monthIndex + '-' + day;
            // console.log("outt", outputDate)
            break;
        case 'ISODatetime':
            outputDate = year + '-' + monthIndex + '-' + day + ' ' + hours + ":" + minutes + ":" + seconds;
            break;
    }
    return outputDate;
}



// WEBPACK FOOTER //
// ./src/utils/helper.js